import type { IPendingReview } from '~/domain/ShiftReview';
import type { TShiftCardData } from '~/types/ShiftCard';
import { computeHours, formatRate, parseCardDate } from '~/utils/shiftCard';

/** Marshals a pending shift review into the DS shift card's `review-hours` state. */
export const mapPendingReviewToShiftCard = (review: IPendingReview): TShiftCardData => {
  const { shift, professional, offerOwner } = review;
  const isInterview = Boolean(review.isOnsiteInterview);

  const data: TShiftCardData = {
    status: 'review-hours',
    statusLabel: 'Review Hours',
    date: parseCardDate(shift.localDate),
    startTime: shift.localStartTime ?? '',
    endTime: shift.localEndTime,
    hours: computeHours(shift.localStartTime, shift.localEndTime),
    rate: isInterview ? undefined : formatRate(shift.rate),
    profession: review.profession,
    office: offerOwner.officeName ?? '',
    interview: isInterview,
  };

  if (professional.fullName || professional.image) {
    data.person = {
      ...(professional.fullName ? { name: professional.fullName } : {}),
      ...(professional.image ? { avatarUrl: professional.image } : {}),
    };
  }

  return data;
};
